export default __webpack_public_path__ + "static/media/ic_dialog_confirm.574fc5a1.svg";